import { createContext, ReactNode, useContext } from 'react';

import { QuestionsReporData } from '../types';

export const CreateReportContext = createContext<QuestionsReporData>({
  body: {} as any,
  header: {} as any,
  values: {},
});

export function ReportContext({
  children,
  value,
}: {
  children: ReactNode;
  value: QuestionsReporData;
}) {
  return (
    <CreateReportContext.Provider value={value}>
      {children}
    </CreateReportContext.Provider>
  );
}

export function useReport() {
  const context = useContext(CreateReportContext);

  if (!context) {
    throw new Error('useReport must be used within a ReportContext');
  }

  return context;
}
